import { render, staticRenderFns } from "./BorderDashedIcon.vue?vue&type=template&id=03054d7e&"
import script from "./BorderDashedIcon.vue?vue&type=script&lang=js&"
export * from "./BorderDashedIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports